import GenericError from "components/GenericError/GenericError"
import { useAppErrorApiContext, useAppErrorDataContext } from "context/AppErrorContext"

function GlobalError() {

    const { global_error } = useAppErrorDataContext()
    const { resetGlobalError } = useAppErrorApiContext()

    return (
        <>
            { global_error.message || global_error.tag ? (
                <GenericError
                    error_message={
                        global_error.message as string
                    }
                    onCloseModal={() => {
                        resetGlobalError()
                    }}
                    tag={global_error.tag}
                />
            ) : (
                <></>
            )}
        </>
        
    )
}

export default GlobalError